import React, { Component } from "react";
import { Helmet } from "react-helmet";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import './ErrorPage.css';

class ErrorPage extends Component {
  render() {
    return (
      <PageWrapper context="error">
        <Helmet title={`Videos for Change | 404 Page not found`} />
		<div className="container">
		<div className="content">
        <h1>404 Page not found!</h1>
        <p>The page you're looking for can't be found</p>
		</div>
		</div>
      </PageWrapper>
    );
  }
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/pages/ErrorPage/ErrorPage.js